var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowTick24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12.5C22.5 13.9844 21.5625 15.2344 20.2344 15.7422C20.8203 16.9922 20.5859 18.5547 19.5703 19.5703C18.5156 20.625 16.9922 20.8594 15.7031 20.2734C15.1953 21.6016 13.9453 22.5 12.5 22.5C11.0156 22.5 9.76562 21.6016 9.25781 20.2734C8.00781 20.8594 6.44531 20.625 5.42969 19.5703C4.375 18.5547 4.14062 16.9922 4.72656 15.7422C3.39844 15.2344 2.5 13.9844 2.5 12.5C2.5 11.0547 3.39844 9.80469 4.72656 9.29688C4.14062 8.04688 4.375 6.48438 5.42969 5.42969C6.44531 4.41406 8.00781 4.17969 9.25781 4.76562C9.76562 3.4375 11.0156 2.5 12.5 2.5C13.9453 2.5 15.1953 3.4375 15.7031 4.76562C16.9531 4.17969 18.5156 4.41406 19.5703 5.42969C20.5859 6.48438 20.8203 8.04688 20.2344 9.29688C21.5625 9.80469 22.5 11.0547 22.5 12.5ZM16.8359 10.7812C16.9922 10.625 16.9922 10.3516 16.8359 10.1953L15.8203 9.17969C15.6641 8.98438 15.3906 8.98438 15.1953 9.17969L11.4062 12.9297L9.76562 11.2891C9.60938 11.0938 9.33594 11.0938 9.14062 11.25L8.125 12.2656C7.96875 12.4609 7.96875 12.7344 8.125 12.8906L11.0938 15.8594C11.25 16.0156 11.5234 16.0547 11.7188 15.8594L16.8359 10.7812Z",
    fill: "url(#paint0_linear_918_29214)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_918_29214",
    x1: 3.86842,
    y1: 3.15789,
    x2: 21.0263,
    y2: 21.4737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEDAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowTick24Px);
export default __webpack_public_path__ + "static/media/yellow-tick-24px.e4e601244e78784fde775c569f3009c9.svg";
export { ForwardRef as ReactComponent };